import React from 'react';
import PropTypes from 'prop-types';
var filterStyleParams = function (styleParams) {
    var requiredStyleParams = [
        'cubeType',
        'cubeImages',
        'cropRatio',
        'collageAmount',
        'collageDensity',
        'columnsWidth',
        'cropOnlyFill',
        'chooseBestGroup',
        'externalInfoHeight',
        'externalInfoWidth',
        'fixedColumns',
        'groupsPerStrip',
        'galleryMargin',
        'groupTypes',
        'groupSize',
        'isVertical',
        'imageMargin',
        'minItemSize',
        'scrollDirection',
        'placeGroupsLtr',
        'rotatingGroupTypes',
        'rotatingCropRatios',
        'smartCrop',
        'scatter',
        'smartCrop',
        'targetItemSize',
        'hasThumbnails',
        'thumbnailSize',
        'galleryMargin',
        'thumbnailSpacings',
        'galleryThumbnailsAlignment',
        'isSlideshow',
        'slideshowInfoSize',
    ];
    return Object.keys(styleParams)
        .filter(function (key) { return requiredStyleParams.indexOf(key) >= 0; })
        .reduce(function (res, key) {
        res[key] = styleParams[key];
        return res;
    }, {});
};
var hashToInt = function (str) {
    if (str === void 0) { str = ''; }
    var int = 0;
    for (var i = 0; i < str.length; i++) {
        int += str.charCodeAt(i);
    }
    return int;
};
export var LayoutFixer = function (props) {
    try {
        var itemsStr = props.items
            .slice(0, 20)
            .map(function (item) { return hashToInt(item.mediaUrl) + "_" + (item.width || item.metaData.width) + "_" + (item.height || item.metaData.height); })
            .join('|');
        var stylesStr = Object.entries(filterStyleParams(props.styles))
            .map(function (keyval) { return keyval.join('_'); })
            .join('|');
        var hrefStr = "/_serverless/pro-gallery-css-v4-staging-server/layoutCss?id=" + props.id + "&items=" + itemsStr + "&styles=" + stylesStr + "&container=";
        return (React.createElement("div", { id: 'layout-fixer-' + props.id, key: 'layout-fixer-' + props.id, style: { display: 'none' } },
            React.createElement("link", { rel: "stylesheet", id: 'layout-fixer-style-' + props.id }),
            React.createElement("script", { dangerouslySetInnerHTML: {
                    __html: "try {\n            window.requestAnimationFrame(function() {\n              var pgMeasures = document.getElementById('" + ('pro-gallery-' + props.id) + "').getBoundingClientRect();\n              var layoutFixerUrl = 'https://' + window.location.host + '" + hrefStr + "' + pgMeasures.top + '_' + pgMeasures.width + '_' + pgMeasures.height + '_' + window.innerHeight;\n              document.getElementById('" + ('layout-fixer-style-' + props.id) + "').setAttribute('href', encodeURI(layoutFixerUrl));\n            });\n        } catch (e) {\n          console.warn('Cannot set layoutFixer css', e);\n        }",
                } })));
    }
    catch (e) {
        return React.createElement("div", { id: "layoutFixerErrors", style: { display: 'none' } }, e);
    }
};
/*
const hrefStr = `www.wix.com/_serverless/pro-gallery-css-v4-staging-server/layoutCss?id=${props.id}&items=${itemsStr}&styles=${stylesStr}&container=`;

  return (
    <div
      id={'layout-fixer-' + props.id}
      key={'layout-fixer-' + props.id}
      style={{ display: 'none' }}
    >
      <link rel="stylesheet" type="text/css" href="https://www.wix.com/_serverless/pro-gallery-css-v4-server/layoutCss?id=ssr-simulator&items=1920_1000|3737_5600|5600_3737|5600_3737|5600_3737|5600_3737|5600_3737|5600_3737|5600_3737|5600_3737|5600_3737|5600_3737|5600_3737|5600_3737|5600_3737|3737_5600|3737_5600|5600_3737|5600_3737|4400_3056|4200_2829|2799_4200|4500_3228|5494_3840|4200_2800|4200_2800|4500_3000|5000_3282|4400_2966|4600_3066|5200_3467|4200_2800|2800_4200|1920_1280|5600_3727|3727_5600|5600_3727|5600_3727|5600_3728|5600_3727|3727_5600|5600_3727|5600_3728|5600_3727|5600_3727|5600_3727|5600_3728|5600_3727|5600_3727|5600_3727&styles=isVertical_false|minItemSize_120|chooseBestGroup_true|groupSize_3|groupTypes_1,2v,2h,3r,3b,3t,3l,3v,3h|rotatingGroupTypes_|collageDensity_0.8|cubeImages_false|cubeType_fill|cropRatio_1|cropOnlyFill_false|smartCrop_false|rotatingCropRatios_|fixedColumns_0|groupsPerStrip_0|imageMargin_10|galleryMargin_0|scatter_0|placeGroupsLtr_false|scrollDirection_0|targetItemSize_370&container=8_657_5005.03125"></link>
      <script
        dangerouslySetInnerHTML={{
          __html: `try {
          var pgMeasures = document.getElementById('${
            'pro-gallery-' + props.id
          }').getBoundingClientRect();
          document.head.innerHTML += '<link rel="stylesheet" type="text/css" href="https://' + '' + '${hrefStr}' + pgMeasures.top + '_' + pgMeasures.width + '_' + pgMeasures.height + '"></link>';
        } catch (e) {
          console.warn('Cannot set layoutFixer css', e);
        }`,
        }}
      ></script>
    </div>
  );
};

*/
LayoutFixer.propTypes = {
    isPrerenderMode: PropTypes.bool,
    id: PropTypes.string,
    items: PropTypes.array,
    styles: PropTypes.object,
};
//# sourceMappingURL=layoutFixer.js.map